import Vue from 'vue'
import router from '@/router'
import store from '@/store'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css'
Vue.use(VueToast)

export const helper = {
  catchHandler: (err) => {
    if (err.response && err.response.status === 401) {
      if (router.currentRoute.path !== '/login') { router.push('/login') }
      Vue.$toast.clear()
      Vue.$toast.error(err.response.data.message || 'An unkown error occured please contact suppport')
      store.dispatch('logoutUserFromApp')
      return
      // Vue.$toast.error(err.response.data.message || 'An unkown error occured please contact suppport')
    }
    console.log(err.response || err)
    Vue.$toast.error(err.response.data.message || 'An unkown error occured please contact suppport')
  }
}



// WEBPACK FOOTER //
// ./src/helper/helper.js